var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.999V0H4V1.999H0V3.999H14V1.999H10Z",
    fill: "#888D95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.999V16.999C1 18.101 1.897 18.999 3 18.999H11C12.103 18.999 13 18.101 13 16.999V4.999H1ZM6 15H4V9H6V15ZM10 15H8V9H10V15Z",
    fill: "#888D95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteTwo);
export default __webpack_public_path__ + "static/media/DeleteTwo.54d495f1.svg";
export { ForwardRef as ReactComponent };